/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { School } from '../../models/school';

export interface GetSchool$Params {
  id: string;
}

export function getSchool(http: HttpClient, rootUrl: string, params: GetSchool$Params, context?: HttpContext): Observable<StrictHttpResponse<School>> {
  const rb = new RequestBuilder(rootUrl, getSchool.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<School>;
    })
  );
}

getSchool.PATH = '/school/{id}';
